import type { ReportSubscription } from '@/types/Models/ReportSubscription'
import type { ReportSubscriptionStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import ReportSubscriptionsProxy from '@/proxies/ReportSubscriptionsProxy'

export const useReportSubscriptionStore = defineStore('reportSubscription', {
  state: (): ReportSubscriptionStoreState => ({ subscriptions: [], loading: false }),
  getters: {
    list: (state: ReportSubscriptionStoreState) => state.subscriptions,
    isLoading: (state: ReportSubscriptionStoreState) => state.loading,
    byReportAll: (state: ReportSubscriptionStoreState) => (reportId: number) =>
      state.subscriptions.filter((sub) => sub.reportId === reportId),
  },
  actions: {
    fetchAll() {
      this.loading = true
      return new ReportSubscriptionsProxy()
        .all()
        .then((response) => {
          this.subscriptions = response.data as ReportSubscription[]
          return response
        })
        .finally(() => (this.loading = false))
    },
    subscribe(reportId: number, recipient: string | null, interval: string = 'day', time: string = '09:00:00') {
      return new ReportSubscriptionsProxy().create({ reportId, recipient, interval, time }).then(() => this.fetchAll())
    },
    unsubscribe(subscriptionId: number) {
      return new ReportSubscriptionsProxy().destroy(String(subscriptionId)).then(() => this.fetchAll())
    },
    update(subscriptionId: number, payload: Partial<ReportSubscription>) {
      return new ReportSubscriptionsProxy().update(subscriptionId, payload).then(() => this.fetchAll())
    },
  },
})

export type ReportSubscriptionStore = ReturnType<typeof useReportSubscriptionStore>
